import {HttpClient, HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {Router} from '@angular/router';
import {catchError, switchMap, throwError} from 'rxjs';

export const refreshSessionInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const http = inject(HttpClient);

  return next(req).pipe(
    catchError((error) => {

      // Only handle Laravel CSRF expiration
      if (error.status === 419) {

        // call Sanctum csrf-cookie endpoint
        return http.get('csrf-cookie', {withCredentials: true}).pipe(
          // after refreshing token -> retry original request
          switchMap(() => {
            return next(req);
          }),

          // if refresh also fails -> logout
          catchError((refreshError) => {
            router.navigate(['/login']);
            return throwError(() => refreshError);
          })
        );
      }

      return throwError(() => error);
    })
  );
};
